import { render, staticRenderFns } from "./ModalImportarClassificados.vue?vue&type=template&id=5fa59e2c&scoped=true"
import script from "./ModalImportarClassificados.vue?vue&type=script&lang=ts"
export * from "./ModalImportarClassificados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa59e2c",
  null
  
)

export default component.exports